import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_TASKS_LOGS_DATA: createActionType(FULL_NAMESPACE, "SET_TASKS_LOGS_DATA"),
    SET_TASKS_LOGS_SOCKET_DATA: createActionType(FULL_NAMESPACE, "SET_TASKS_LOGS_SOCKET_DATA"),
    SET_LOG_LEVELS: createActionType(FULL_NAMESPACE, "SET_LOG_LEVELS"),
    SET_PRESENTATION_INTERVAL: createActionType(FULL_NAMESPACE, "SET_PRESENTATION_INTERVAL"),
    SET_TIMELINE_INTERVAL: createActionType(FULL_NAMESPACE, "SET_TIMELINE_INTERVAL"),
    GET_TASKS_LOGS_DATA_FOR_DOCUMENT: createActionType(FULL_NAMESPACE, "GET_TASKS_LOGS_DATA_FOR_DOCUMENT"),
    GET_TASKS_LOGS_DATA_FOR_DOCUMENT_COMPLETED: createActionType(FULL_NAMESPACE, "GET_TASKS_LOGS_DATA_FOR_DOCUMENT_COMPLETED")
};
